module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"finishedplayers":"Answered"},"fi":{"finishedplayers":"Vastanneet"},"sv":{"finishedplayers":"De som svarat"},"de":{"finishedplayers":"Beantwortet"},"ko":{"finishedplayers":"응답완료"}}')
  delete Component.options._Ctor
}
